import { I18nUtils } from '@medable/i18n-core';
import { Locale as I18nLocale } from '@medable/i18n-core-v4';
import { Locale } from 'libs.i18n-core';
export const toI18nLocale = (locale) => I18nUtils.cortexToI18nFormat(locale);
export const toCortexLocale = (locale) => I18nUtils.i18nToCortexFormat(locale);
export const isPseudoLocale = (locale) => {
    if (!locale) {
        return false;
    }
    return new I18nLocale(toI18nLocale(locale)).isPseudoLocale;
};
export const getApiLocale = (locale) => {
    if (!locale || !isPseudoLocale(locale)) {
        return locale;
    }
    return Locale.en_US;
};
// Converts a cortex/i18n locale string to a valid i18n `Locale`, or `undefined` when empty/invalid.
const toValidLocale = (locale) => {
    if (!locale) {
        return undefined;
    }
    const converted = toI18nLocale(locale);
    return Object.values(Locale).includes(converted) ? converted : undefined;
};
/**
 * Resolves the locale site_app's root (dashboard/training) UI should render in.
 *
 * The host app's shared LocaleContext is the source of truth: it is seeded from the profile/identity
 * locale, honors an app-wide pseudo-locale, and updates live. site_app therefore prefers the
 * inherited host locale for both real and pseudo locales. When nothing is inherited (e.g. site_app
 * mounted without a host provider) it falls back to the identity locale (cortex format, e.g.
 * `es_US`), and finally to `en-US`; invalid values are ignored. Pseudo locales are mapped to `en-US`
 * only for API/resource lookup (see the messageProvider), never for the active UI locale.
 */
export const resolveSiteAppLocale = (inheritedLocale, identityLocale) => toValidLocale(inheritedLocale) ?? toValidLocale(identityLocale) ?? Locale.en_US;
/**
 * Resolves the user's global preference independently from the shell's current display locale.
 * A site compatibility locale may temporarily drive the inherited shell while a study is open,
 * but it must not replace the real preference stored on the identity. Pseudo-locales are the one
 * browser-owned global override and therefore continue to take precedence.
 */
export const resolveGlobalPreferenceLocale = (inheritedLocale, identityLocale) => {
    const validInheritedLocale = toValidLocale(inheritedLocale);
    if (validInheritedLocale && isPseudoLocale(validInheritedLocale)) {
        return validInheritedLocale;
    }
    return toValidLocale(identityLocale) ?? validInheritedLocale ?? Locale.en_US;
};
